"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestmentDetailsValidationSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const SPVSchema_1 = require("../../asset/SPVSchema");
const cashFlowTable_1 = require("../../asset/cashFlowTable");
const utils_1 = require("../../utils");
exports.InvestmentDetailsValidationSchema = zod_1.z
    .object({
    stage: zod_1.z.nativeEnum(enums_1.TAssetStage),
    sharePrice: zod_1.z.number(),
    issuingSharePrice: zod_1.z.number().nullable(),
    availableBricks: zod_1.z.number().nullable(),
    totalBricks: zod_1.z.number().min(1),
    expertRating: zod_1.z.number().min(0).max(5),
    appraisalFirm: zod_1.z.string(),
    ISIN: zod_1.z.string(),
    spv: SPVSchema_1.SPVSchema.nullable(),
    issueStartDate: zod_1.z.coerce.date(),
    issueEndDate: zod_1.z.coerce.date(),
    issueFundingFloor: zod_1.z.number(),
    issueEndDateOriginal: zod_1.z.coerce.date().nullable(),
    securityType: zod_1.z.nativeEnum(enums_1.TSecurityType),
    terminationRight: zod_1.z.nativeEnum(enums_1.TTerminationRight),
    terminationRightFrequency: zod_1.z.string(),
    // TODO: correct boolean fields
    maturity: utils_1.booleanField,
    maturityDate: zod_1.z.coerce.date().nullable(),
    landRegisterMortgageStatus: zod_1.z.boolean().nullable(),
    landRegisterMortgageStatusText: zod_1.z.string(),
    landRegisterMortgageDescription: zod_1.z.string(),
    minSubscriptionAmount: zod_1.z.number().max(100),
    estimatedRentIndexation: zod_1.z.number(),
    preparedCashFlowTable: cashFlowTable_1.preparedCashFlowTable,
    cashFlowPerformance: zod_1.z.number(),
    preparedCashFlowTableStressScenario: cashFlowTable_1.preparedCashFlowTable,
    cashFlowPerformanceStressScenario: zod_1.z.number(),
    preparedCashFlowTableOptimisticScenario: cashFlowTable_1.preparedCashFlowTable,
    cashFlowPerformanceOptimisticScenario: zod_1.z.number(),
    repaymentAmount: zod_1.z.number(),
    avgRentalSurplusIndexedInY: zod_1.z.number(),
    avgInterestAndFeesInY: zod_1.z.number(),
    avgRepaymentAmountInY: zod_1.z.number(),
    maturityDateOnlyExpectedTerminationRight: zod_1.z.boolean(),
    forumActive: zod_1.z.boolean(),
    totalConstructionVolume: zod_1.z.number(),
    totalConstructionVolumeNote: zod_1.z.string(),
    publicFunding: zod_1.z.number(),
    publicFundingNote: zod_1.z.string(),
    brokerageFeeForEndCustomers: zod_1.z.boolean(),
    accountName: zod_1.z.string(),
    iban: zod_1.z.string(),
    bic: zod_1.z.string(),
    companyName: zod_1.z.string(),
    companyDescription: zod_1.z.string(),
    yield: zod_1.z.number(),
    yieldIntroductoryText: zod_1.z.string(),
    yieldFieldname: zod_1.z.string(),
    yieldInfoIcon: zod_1.z.string(),
})
    .partial()
    .refine((data) => {
    if (data.maturity && !data.maturityDate)
        return false;
    return true;
}, { message: 'Maturity date is required if maturity is set to true' })
    .refine((data) => {
    if (data.sharePrice && data.sharePrice < 1)
        return false;
    return true;
}, { message: 'Share price must be greater than 1' })
    .refine((data) => {
    if (data.terminationRight !== enums_1.TTerminationRight.no && !data.terminationRightFrequency) {
        return false;
    }
    return true;
}, {
    message: 'Termination right frequency is required if termination right is set to no',
    path: ['terminationRightFrequency'],
});
//# sourceMappingURL=investmentDetails.js.map